<template>
  <div>
    <Dialog
      :visible.sync="activityResultForm1"
      :style="{ width: '640px', overflowY: 'auto' }"
      header="Activity Result Details"
      :modal="true"
      class="p-fluid"
    >
      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="resultCode">Result Code*</label>
          <InputText
            id="resultCode"
            v-model.trim="activityResult.resultCode"
            required="true"
            autofocus
            :class="{ 'p-invalid': submitted && !activityResult.resultCode }"
            :disabled="disabledArr.includes('resultCode')"
          />
          <small
            class="p-invalid"
            v-if="submitted && !activityResult.resultCode"
            >ActivityResult Code is required.</small
          >
        </div>
        <div class="p-field p-col">
          <label for="lastName">Mark Active</label>
          <SelectButton
            v-model="activityResult.active"
            :options="options"
            optionLabel="name"
          />
        </div>
      </div>

      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="resultCode">Result Description*</label>
          <Textarea
            v-model="activityResult.resultDesc"
            :autoResize="true"
            rows="2"
          />
        </div>
      </div>

      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="showsOn">Shows on</label>
          <Dropdown
            id="showsOn"
            v-model="activityResult.showsOn"
            :options="showsOnOptions"
            optionLabel="label"
            optionValue="value"
            placeholder="Both"
          />
          <small>Which records it is offered for: Tasks, Activities or both.</small>
        </div>
      </div>

      <template #footer>
        <Button
          label="Reset"
          icon="pi pi-refresh"
          class="p-button-text"
          @click="reset"
        />
        <Button
          label="Save"
          icon="pi pi-check"
          class="p-button-text"
          @click="save"
        />
        <Button
          label="Cancel"
          icon="pi pi-times"
          class="p-button-text"
          @click="cancel"
        />
      </template>
    </Dialog>
  </div>
</template>

<script>
import { SHOWS_ON_OPTIONS } from "@/mbp/activityKind.js";
export default {
  props: ["activityResultToEdit", "activityResultForm", "disabledArr"],
  data: () => ({
    showsOnOptions: SHOWS_ON_OPTIONS,
    activityResult: {},
    submitted: false,
    options: [
      { name: "Active", value: true },
      { name: "Inactive", value: false }
    ]
  }),
  created() {
    if (this.activityResultToEdit && this.activityResultToEdit.id) {
      this.activityResult = { ...this.activityResultToEdit };
      this.activityResultToEdit.active
        ? (this.activityResult.active = { name: "Active", value: true })
        : (this.activityResult.active = { name: "Inactive", value: false });
    }
  },
  computed: {
    activityResultForm1: {
      set(val) {
        if (!val) {
          this.cancel();
        }
      },
      get() {
        return this.activityResultForm ? true : false;
      }
    }
  },
  methods: {
    reset() {
      this.activityResult = {};
    },
    save() {
      this.submitted = true;

      if (this.activityResult.resultCode) {
        if (this.activityResult.active instanceof Object) {
          this.activityResult.active = this.activityResult.active.value;
        }

        this.$emit("save", this.activityResult);
      }
    },
    cancel() {
      this.$emit("close");
    }
  }
};
</script>

<style></style>
